// extracted by mini-css-extract-plugin
export var aircallIframe = "_ir-3";
export var fabContainer = "_ir-5";
export var fabRinging = "_ir-6";
export var loadingOverlay = "_ir-4";
export var pulse = "_ir-7";
export var widgetContent = "_ir-2";
export var widgetPanel = "_ir-0";
export var widgetPanelExpanded = "_ir-1";